import React from 'react';
import { useSettingsState } from '../../components/context/SettingsContext';

const Loader = ({ inline, color, size = 40, light = false }) => {
  const { theme } = useSettingsState();
  const strokeWidth = light ? 3 : 5;
  const spinnerColor = color || theme.primaryColor;

  return (
    <div
      className={`
        ${inline ? '' : 'absolute inset-0 flex items-center justify-center'}
        font-[0] leading-[0]
      `}
    >
      <svg
        viewBox="0 0 50 50"
        className={`animate-spin-slow z-10`}
        style={{ width: size, height: size }}
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={spinnerColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          className="animate-dash"
        />
      </svg>
    </div>
  );
};

export default Loader;
